import { readJson, removeEntriesExcept, writeJson } from './localStore';
import { DEFAULT_APP_SETTINGS, type AppSettings } from './types';

const APP_KEY = 'settings';

// App preferences are the only thing kept in browser storage (ADR 0007). Updates read, merge
// and write synchronously, so quick successive updates can't overwrite each other.

/** Synchronous read, for startup (applying the theme before the first paint). */
export function readAppSettings(): AppSettings {
  return { ...DEFAULT_APP_SETTINGS, ...(readJson(APP_KEY) as Partial<AppSettings> | undefined) };
}

export async function getAppSettings(): Promise<AppSettings> {
  return Promise.resolve(readAppSettings());
}

export async function updateAppSettings(patch: Partial<AppSettings>): Promise<AppSettings> {
  const next = { ...readAppSettings(), ...patch };
  writeJson(APP_KEY, next);
  return Promise.resolve(next);
}

/** Startup: drop song data that earlier versions saved, keeping only app settings. */
export function removeLegacySongData(): void {
  removeEntriesExcept([APP_KEY]);
}
